export const ADMIN_CHANNEL_SECTIONS = {
  whatsapp: ["groups", "provider"],
  telegram: ["channels"],
} as const;

export type AdminChannelNetwork = keyof typeof ADMIN_CHANNEL_SECTIONS;
export type AdminChannelSection = (typeof ADMIN_CHANNEL_SECTIONS)[AdminChannelNetwork][number];

export interface AdminChannelsSearch {
  network: AdminChannelNetwork;
  section: AdminChannelSection;
}

function parseNetwork(value: unknown): AdminChannelNetwork {
  return value === "telegram" ? "telegram" : "whatsapp";
}

/** Reads the network tab and one of that network's sub-sections, defaulting to the first. */
export function parseAdminChannelsSearch(raw: Record<string, unknown>): AdminChannelsSearch {
  const network = parseNetwork(raw.network);
  const sections: readonly AdminChannelSection[] = ADMIN_CHANNEL_SECTIONS[network];
  const section = sections.find((candidate) => candidate === raw.section) ?? sections[0]!;
  return { network, section };
}
